import { EMAIL_KEY } from '@yme/common/hooks';
export const BACK_IN_STOCK_MODAL_HEIGHT = '192px';
export const CONFIGURATION_FORM = [
    {
        type: EMAIL_KEY,
        errorCode: [],
        required: true,
        isTouched: false,
        isEmpty: true,
    },
];
